

































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";

@Component({
    components: {
        EstateCard: () => import("./card.vue"),
        ElSelect: () => import("../../elements/forms/select.vue"),
        ElPriceSelect: () => import("../../elements/forms/price-select.vue")
    }
})
export default class EstatesFilter extends Vue {
    @Prop({ default: ":count panden" }) title?: string;

    @Prop({ default: () => {} }) preset?: SweepbrightParams;

    loading: boolean = false;

    open: boolean = false;

    params: SweepbrightParams = {
        per_page: 9,
        page: 0,
        type: "",
        bedrooms: "",
        sort: "putOnlineDateTime,desc",
        cities: "",
        price: false
    };

    pageData = {
        current: 0,
        next: 1,
        last: 1,
        total: 0
    };

    estates: Estate[] = [];

    cityOptions: Array<{ value: string; label: string }> = [];

    typeOptions: Array<{ value: string; label: string }> = [
        { value: "house", label: "Woning" },
        { value: "apartment", label: "Appartement" },
        { value: "parking", label: "Parking" },
        { value: "land", label: "Grond" },
        { value: "office", label: "Kantoor" },
        { value: "commercial", label: "Commercieel" },
        { value: "industrial", label: "Industrieel" }
    ];

    bedroomOptions: Array<{ value: string; label: string }> = [
        { value: "1", label: "1+ slaapkamers" },
        { value: "2", label: "2+ slaapkamers" },
        { value: "3", label: "3+ slaapkamers" },
        { value: "4", label: "4+ slaapkamers" }
    ];

    sortOptions: Array<{ value: string; label: string }> = [
        { value: "putOnlineDateTime,desc", label: "Nieuwste eerst" },
        { value: "updateDateTime,desc", label: "Recent aangepast" },
        { value: "price,asc", label: "Laagste prijs eerst" },
        { value: "price,desc", label: "Hoogste prijs eerst" }
    ];

    getMobileEstates() {
        this.estates = [];
        this.getEstates();
    }

    @Debounce(500)
    handleFilterChanged() {
        // Only autofetch on desktops
        if (window.outerWidth > 1024) {
            this.estates = [];
            this.params.page = 0;
            this.params.per_page = 9;
            this.getEstates();
        }
    }

    get computedTitle() {
        if (!this.title) {
            return "";
        }

        return this.title.replace(":count", `${this.pageData.total}`);
    }

    private mounted() {
        this.getCities();
        this.getEstates();
    }

    private loadMore() {
        this.params.page = this.pageData.next;
        this.params.per_page = 9;
        this.getEstates();
    }

    private getEstates() {
        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/estates", { params: { ...this.params, ...this.preset } })
            .then((response: { data: PaginatedEstates }) => {
                this.pageData.current = response.data.page;
                this.pageData.next = this.pageData.current + 1;
                this.pageData.total = parseInt(response.data.total, 10);
                this.pageData.last = Math.round(this.pageData.total / this.params.per_page);
                this.addOrSetEstates(response.data);

                if (this.pageData.current === this.pageData.last) {
                    console.log("hit bottom, query sold 10");
                    this.getSoldEstates();
                }
            })
            .finally(() => {
                this.loading = false;
                this.open = false;
            });
    }

    private getSoldEstates() {
        this.loading = true;
        const params = { ...this.params };
        params.page = 0;
        params.per_page = 9;
        params.state = "sold";
        // @ts-ignore
        axios
            .get("/api/estates", { params: { ...params, ...this.preset } })
            .then((response: { data: PaginatedEstates }) => {
                this.addOrSetEstates(response.data);
            })
            .finally(() => {
                this.loading = false;
                this.open = false;
            });
    }

    private getCities() {
        // @ts-ignore
        axios.get("/api/cities").then((response: any) => {
            const cities = {};
            response.data.forEach((city: { name: string; zip: string }) => {
                if (cities.hasOwnProperty(city.name)) {
                    // @ts-ignore
                    cities[city.name].value = cities[city.name].value += `,${city.zip}`;
                } else {
                    // @ts-ignore
                    cities[city.name] = { label: city.name, value: city.zip };
                }
            });

            this.cityOptions = Object.values(cities);
        });
    }

    private addOrSetEstates(estates: PaginatedEstates) {
        this.estates = [...this.estates, ...estates.data];
    }
}
